import React from "react";
import BriefConversationForm from "./BriefConversationForm";
import CaptchProvider from "../../common/CaptchContext";

const BriefConversation = ({ formtext }) => {
  return (    
    <section className="ttm-row bottomzero-padding-section position-relative z-1 clearfix pt-0">
      <div className="formContentBox">
        <div className="container-xl">
          <div className="col-lg-12">
            <div className="spacing-9 spacing9">
              <div className="section-title with-desc clearfix">
                <div className="scheduleFormText">
                  {formtext}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-xl">
        <div className="row no-gutters">
          <div className="col-lg-12">
            <div className="spacing-10 ttm-bgcolor-grey ttm-bg ttm-col-bgcolor-yes spacing10">
              <div className="ttm-col-wrapper-bg-layer ttm-bg-layer ttmbglayer">
                <div className="ttm-bg-layer-inner ttmbglayerinner" />
              </div>
              <div className="section-title with-desc clearfix">
                <div className="title-header">
                  <h2 className="title">Lets schedule a <span>Brief Conversation!</span></h2>
                </div>
              </div>
              <CaptchProvider>
                <BriefConversationForm />
              </CaptchProvider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BriefConversation;
